import { useId, useState, type ReactNode } from 'react';
import { UMIcon } from '../../../urbanmap/_components/UMIcon';
import { UMR } from '../../../urbanmap/_components/referenceTokens';

/** Local UMLayerGroup variant: no layer checkbox; mounted content and full ARIA.
 * UMButton / UMLayerGroup do not expose aria-expanded/controls or keep children mounted.
 */
export function SelectionSection({ title, children, defaultOpen = false }: { title: string; children: ReactNode; defaultOpen?: boolean }) {
  const [open, setOpen] = useState(defaultOpen);
  const id = useId();
  return <section className="um-layer-group" data-selection-section={title}
    style={{ borderBottom: `1px solid ${UMR.borderSubtle}`, paddingBottom: 16, marginBottom: 8 }}>
    <button type="button" aria-label={`${open ? 'Replier' : 'Déplier'} ${title}`}
      aria-expanded={open} aria-controls={id} onClick={() => setOpen((value) => !value)}
      style={{ display: 'flex', alignItems: 'center', gap: 4, width: '100%',
        border: 'none', background: 'transparent', padding: 0, cursor: 'pointer',
        fontFamily: UMR.font, color: UMR.black, textAlign: 'left' }}>
      <UMIcon name={open ? 'keyboard_arrow_up' : 'keyboard_arrow_down'} size={18} box={24} color={UMR.black} />
      <span style={{ flex: 1, minWidth: 0, fontSize: 14, lineHeight: '24px' }}>{title}</span>
    </button>
    <div id={id} hidden={!open} style={{ margin: '4px 0 0 28px' }}>
      {children}
    </div>
  </section>;
}
